import React from "react";
import { Col, Row, Card, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NoteCardSingle from "./NoteCardSingle";
import useNote from "../hooks/useNote";
import '../css/note.css'
import NoteNewNote from "./NoteNewNote";
import { Link } from "react-router-dom";

const NoteBlock = ({ name, notes, user, cardClass, parentItem, limit=5, newNoteAllowed=true }) => {
  const {
    openBlocks,
    toggleBlockState,
    newNoteVisible,
    toggleNewNoteState,
  } = useNote();

  const isNewNoteAllowed = newNoteAllowed && user?.permissions?.includes("pwaCreateNote");

  // ha nem hozhat létre megjegyzést és nincs is semmilyen megjegyzés akkor nem is jelenítjük meg
  if (!isNewNoteAllowed && notes.length==0) {
      return (<></>);
  }  

  return (
    <Col key={name} xs={12} md={12} lg={12}>
      <Card border="light" className={`note-container ${cardClass?cardClass:""}`}>
        <Card.Header
          className={`d-flex justify-content-between align-items-center`}
          //className={`d-flex justify-content-between align-items-center ${!isOpen ? "round" : ""}`}
          // onClick={() => toggleNoteState(note.id)}
          onClick={() => toggleBlockState(name)}
        >
          {/* Bal oldalon ikon és név */}
          <div className="d-flex align-items-center">
            <FontAwesomeIcon className="icon peach" icon={"message"} />
            <strong className="ms-2">Megjegyzés</strong>
          </div>

          {/* Jobb oldalon gomb */}
          <div className="d-flex align-items-center">
            {
              notes.length>0 && (
                  <span className="btn button btn-flt-r ms-2  peach-bg">
                  <FontAwesomeIcon
                    icon={
                      openBlocks[name]
                        ? "fa-solid fa-chevron-up"
                        : "fa-solid fa-chevron-down"
                    }
                  />
                </span>
            )}
          </div>
        </Card.Header>

        <Card.Body className="new-note-container my-2">
          
            {/* <Container className="new-note"> */}
            {isNewNoteAllowed && (
                <Container className={`new-note ${newNoteVisible[name] ? "hidden" : ""}`}>
                  <button
                    className={"btn button my-2"}
                    onClick={(e) => {
                      toggleNewNoteState(name);
                    }}
                  >
                    Új megjegyzés
                  </button>
                </Container>
            )}

            {newNoteVisible[name] && isNewNoteAllowed && (
              <NoteNewNote name={name} toggleNewNoteState={toggleNewNoteState} parentItem={parentItem} />
            )}
          
            {notes.length > 0 && openBlocks[name] && (
              <div className="note-list-container">
                {(limit === 0 ? notes : notes.slice(0, limit)).map((note) => (
                  <NoteCardSingle key={note.id} note={note} name={name} />
                ))}
              </div>
            )}

            {limit > 0 && notes.length > limit && openBlocks[name] && (
              <div className="note-show-more-container">
                <Link
                  className={"note-show-more"}
                  to={`/notelist/${parentItem.id}`}
                >
                  Korábbi megjegyzések megtekintése{" "}
                  <small>(+{notes.length - limit})</small>{" "}
                  <FontAwesomeIcon icon={"fa-solid fa-chevron-right"} />
                </Link>
              </div>
            )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default NoteBlock; 
